import Thumbnail from '../../../components/images/thumbnail/Thumbnail';
import { Button, Container, Form, Modal } from 'react-bootstrap';
import React, { useRef, useState } from 'react';


const DashboardTab = () => {
    const [certificates, setCertificates] = useState(() => {
        if(localStorage.getItem('certificates')) {
            return JSON.parse(localStorage.getItem('certificates'));
        } else {
            return [];
        }
    });

    return (
        <Container className='bg-dark d-flex p-2 mb-3 rounded-bottom'>
            {certificates.map((certificate, index) => (
                <Thumbnail key={index}
                    className='w-10'
                    src={process.env.PUBLIC_URL+"/default_certificate.png"}
                />
            ))}

            <AddCertificateButton certificates={certificates} setCertificates={setCertificates} />
        </Container>
    );
};

const AddCertificateButton = ({ certificates, setCertificates }) => {
    const [show, setShow] = useState(false);
    const [step, setStep] = useState(0);
    const [selectedCertificate, setSelectedCertificate] = useState({});

    const [name, setName] = useState("");
    const [role, setRole] = useState("");
    const [place, setPlace] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [website, setWebsite] = useState("");
    
    const [author, setAuthor] = useState("");
    const [title, setTitle] = useState("");
    const [year, setYear] = useState("");
    const [technique, setTechnique] = useState("");
    const [size, setSize] = useState("");
    const [signature, setSignature] = useState("");
    const [issue, setIssue] = useState("");
    const [serial, setSerial] = useState("");
    const [description, setDescription] = useState("");
    const [from, setFrom] = useState("");
    const [notes, setNotes] = useState("");


    const submitButtonRef = useRef();

    const createCertificate = (e) => {
        e.preventDefault();

        // store the new certificate in local storage
        const newCertificate = {
            certificateId: Math.floor(Math.random() * 1000),
            name: name,
            role: role,
            place: place,
            address: address,
            phone: phone,
            email: email,
            website: website,
            artwork: {
                author: author,
                title: title,
                year: year,
                technique: technique,
                size: size,
                signature: signature,
                issue: issue,
                serial: serial,
                description: description,
                from: from,
                notes: notes
            }
        };

        // add the new certificate to the list of certificates in local storage; if the selectedCertificate is not empty, update the certificate
        if(selectedCertificate.certificateId) {
            const updatedCertificates = certificates.map(certificate => {
                if(certificate.certificateId === selectedCertificate.certificateId) {
                    return newCertificate;
                } else {
                    return certificate;
                }
            });

            localStorage.setItem('certificates', JSON.stringify(updatedCertificates));
            setCertificates(updatedCertificates);
        } else {
            localStorage.setItem('certificates', JSON.stringify([...certificates, newCertificate]));
            setCertificates([...certificates, newCertificate]);
        }

        setShow(false);
        setSelectedCertificate({});
    };


    return (
        <>
            <Modal size="lg" show={show} fullscreen="md-down" scrollable centered onHide={() => setShow(false)}>
                <Modal.Header className="bg-dark rounded-md-top" closeButton>
                    <Modal.Title>Create new Certificate</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark">
                    <Form encType="multipart/form-data" onSubmit={createCertificate} className='flex-center flex-column' >
                        {step === 0 &&
                            <>

                                <h3>Your information</h3>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="nameBox" >
                                    <Form.Label className="ms-3">Your full name</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Expert's name" onChange={e => setName(e.target.value)} aria-describedby="name" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="roleBox" >
                                    <Form.Label className="ms-3">Title/Role</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Role" onChange={e => setRole(e.target.value)} aria-describedby="role" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="placeBox" >
                                    <Form.Label className="ms-3">Place</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Place" onChange={e => setPlace(e.target.value)} aria-describedby="place" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="addressBox" >
                                    <Form.Label className="ms-3">Address</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Address" onChange={e => setAddress(e.target.value)} aria-describedby="address" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="phoneBox" >
                                    <Form.Label className="ms-3">Phone</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Phone" onChange={e => setPhone(e.target.value)} aria-describedby="phone" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="emailBox" >
                                    <Form.Label className="ms-3">Email</Form.Label>
                                    <Form.Control className="bg-darker" type="email" placeholder="Email" onChange={e => setEmail(e.target.value)} aria-describedby="email" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="websiteBox" >
                                    <Form.Label className="ms-3">Website</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Website" onChange={e => setWebsite(e.target.value)} aria-describedby="website" />
                                </Form.Group>

                                <h3 className='mt-3'>Artwork information</h3>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="authorBox" >
                                    <Form.Label className="ms-3">Author</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Author" onChange={e => setAuthor(e.target.value)} aria-describedby="author" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="titleBox" >
                                    <Form.Label className="ms-3">Title</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Title" onChange={e => setTitle(e.target.value)} aria-describedby="title" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="yearBox" >
                                    <Form.Label className="ms-3">Year</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Year" onChange={e => setYear(e.target.value)} aria-describedby="year" />
                                </Form.Group>
                                
                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="techniqueBox" >
                                    <Form.Label className="ms-3">Technique</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Technique" onChange={e => setTechnique(e.target.value)} aria-describedby="technique" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="sizeBox" >
                                    <Form.Label className="ms-3">Size</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Size" onChange={e => setSize(e.target.value)} aria-describedby="size" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="signatureBox" >
                                    <Form.Label className="ms-3">Signature</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Signature" onChange={e => setSignature(e.target.value)} aria-describedby="signature" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="issueBox" >
                                    <Form.Label className="ms-3">Issue</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Issue" onChange={e => setIssue(e.target.value)} aria-describedby="issue" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="serialBox" >
                                    <Form.Label className="ms-3">Serial</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Serial" onChange={e => setSerial(e.target.value)} aria-describedby="serial" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="descriptionBox" >
                                    <Form.Label className="ms-3">Description</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Description" onChange={e => setDescription(e.target.value)} aria-describedby="description" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="fromBox" >
                                    <Form.Label className="ms-3">From</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="From" onChange={e => setFrom(e.target.value)} aria-describedby="from" />
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="notesBox" >
                                    <Form.Label className="ms-3">Notes</Form.Label>
                                    <Form.Control className="bg-darker" type="text" placeholder="Notes" onChange={e => setNotes(e.target.value)} aria-describedby="notes" />
                                </Form.Group>
                                
                            </>
                        }

                        <Button type="submit" className="hidden" ref={submitButtonRef} />
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer className="bg-dark justify-content-between gap-2 rounded-md-bottom">
                    <Button variant="dark" className="border-secondary" onClick={() => setShow(false)} >
                        <span>Cancel</span>
                    </Button>
                    {step === 0 &&
                        <Button variant="warning" className="px-4 px-lg-3" type="button" onClick={() => setStep(1)} aria-describedby="next">
                            <span className='text-dark'>
                                Next
                            </span>
                        </Button>
                    }
                    {step === 1 &&
                        <Button variant="warning" className="px-4 px-lg-3" type="button" onClick={() => submitButtonRef.current.click()} aria-describedby="save">
                            <span className='text-dark'>
                                Save
                            </span>
                        </Button>
                    }
                </Modal.Footer>
            </Modal>

            <Button
                variant="link"
                className="position-absolute bottom-0 end-0 d-flex p-0 m-5"
                onClick={() => {
                    setShow(true);
                    setStep(0);
                }}
                aria-describedby="new certificate"
            >
                <box-icon name='plus-circle' size='lg' type='solid' color='#ffc107' ></box-icon>
            </Button>
        </>
    );
};


export default DashboardTab;